import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';
import {emailHeaderCompanyLogo} from '../../helpers/commonEmailComponents';

export default function afterSaleTermNonblend(params: QuoteTemplateParams) {
    const {name, monthly_premium: monthlyPremium, term_period: termPeriod, face_amount: faceAmount} = params;

    return `
${emailHeaderCompanyLogo}
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">Hi
            there ${highlightYellow(name)},</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">It
            was great speaking with you today! Thank you for trusting us with your financial future.</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">Following
            up on our discussion, your life insurance policies can provide:</span>
    </p>
    <ul  style="padding: 0;margin: 0;list-style-type: none;">
        <li 
            style="color: #000000;font-size: 11pt;font-family: 'Arial';margin-left: 36pt;padding-top: 0pt;padding-left: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
            <span 
                style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">Immediate
                life insurance protection</span>
        </li>
        <li 
            style="color: #000000;font-size: 11pt;font-family: 'Arial';margin-left: 36pt;padding-top: 0pt;padding-left: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
            <span 
                style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">Immediate
                critical, chronic, and terminal illness protection</span>
        </li>
        <li 
            style="color: #000000;font-size: 11pt;font-family: 'Arial';margin-left: 36pt;padding-top: 0pt;padding-left: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
            <span>A way to protect your family should you pass in the next </span><span 
                style="font-weight: 700;">${termPeriod}</span><span 
                style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">
                years</span>
        </li>
    </ul>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;margin-left: 36pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';background-color: #ffffff;padding-top: 0pt;padding-bottom: 0pt;line-height: 1.64;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="font-size: 15pt;font-family: 'Georgia';color: #5ae288;font-weight: 700;">Life Insurance
            Plan Summary for ${highlightYellow(name)}</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="background-color: #ffffff;font-size: 12pt;font-family: 'Georgia';font-weight: 400;">&#9989;
        </span><span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">${faceAmount}
            life, critical, chronic, and terminal illness protection for ${termPeriod} years</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span class="c6"
            style="background-color: #ffffff;font-size: 12pt;font-family: 'Georgia';font-weight: 400;">&#9989;
        </span><span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">${monthlyPremium}
            per month</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span class="c7"
            style="color: #000000;font-weight: 700;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">You
            will be getting some follow up emails from me with additional information on the timeline, your personalized
            policy, and all of the awesome benefits of working with Amplify. </span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span>In the meantime, should you have any questions, please don&rsquo;t hesitate to reach out to me via call,
            text or email at any time. You can also check out our</span><span class="c5"
            style="text-decoration-skip-ink: none;-webkit-text-decoration-skip: none;color: #1155cc;text-decoration: underline;"><a
                href="https://getamplifylife.com/learn/faq"
                style="color: inherit;text-decoration: inherit;">&nbsp;frequently asked questions</a></span><span>, our
        </span><span class="c5"
            style="text-decoration-skip-ink: none;-webkit-text-decoration-skip: none;color: #1155cc;text-decoration: underline;"><a
                href="https://getamplifylife.com/learn/blog"
                style="color: inherit;text-decoration: inherit;">knowledge base</a></span><span>&nbsp;and our
        </span><span class="c5"
            style="text-decoration-skip-ink: none;-webkit-text-decoration-skip: none;color: #1155cc;text-decoration: underline;"><a
                href="https://getamplifylife.com/learn/glossary"
                style="color: inherit;text-decoration: inherit;">glossary</a></span><span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">&nbsp;for
            a quick answer to some common questions that others have had.</span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;height: 11pt;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;"></span>
    </p>
    <p 
        style="margin: 0;color: #000000;font-size: 11pt;font-family: 'Arial';padding-top: 0pt;padding-bottom: 0pt;line-height: 1.15;orphans: 2;widows: 2;text-align: left;">
        <span 
            style="color: #000000;font-weight: 400;text-decoration: none;vertical-align: baseline;font-size: 11pt;font-family: 'Arial';font-style: normal;">Cheers,</span>
    </p>
    ${highlightYellow('[Agent...]')}
	`;
}
